import { ITeam, ITeamConfig } from "../slices/teamSlice";
import { getIdArrayFromObjectList, transformForLookupList } from "./transformLookup";

export const transformTeamForDisplay = (payload: any): ITeam => {
    return {
        name: payload.name,
        displayName: payload.displayName,
        fullyQualifiedName: payload.fullyQualifiedName,
        description: payload.description,
        isJoinable: payload.isJoinable,
        deleted: payload.deleted,
        id: payload.id,
        teamType: payload.teamType,
        updatedAt: payload.updatedAt,
        updatedBy: payload.updatedBy,
        tenantId: payload.tenantId,
        tenantName: payload.tenantName,
        tierType: payload.tierType,
        users: getIdArrayFromObjectList(payload.users, 'id')
    }
}

export const transformTeamConfigForDispaly = (payload: any): ITeamConfig => {
    const returnValue: ITeamConfig = {
        id: payload.id,
        teamId: payload.teamId,
        adminId: payload.adminId,
        name: payload.name,
        fullyQualifiedName: payload.fullyQualifiedName,
        displayName: payload.displayName,
        description: payload.description,
        teamRoles: getIdArrayFromObjectList(payload.teamRoles, 'id'),
        dataSources: payload.dataSources,
        rateLimits: payload.rateLimits,
        deleted: payload.deleted
    };

    return returnValue;
}

export const createTeamConfigPayload = (team: ITeam, config: ITeamConfig, adminId: string): ITeamConfig => {
    return {
        ...config,
        teamId: team.id,
        adminId,
        name: team.name,
        fullyQualifiedName: team.fullyQualifiedName || team.name,
        displayName: team.displayName,
        description: team.description
    }
}